import React from "react";

import { Outlet } from "react-router";

export default function CheckoutWrapper() {
    return (
        <div>
            <Outlet />
        </div>
    );
}
